<template>
  <div class="page-guide">
    
    <div class="">

      <div class="box-item">
        <div class="title1">1.Search by Compound</div>
        <p class="text">You can query the database by providing molecule structures or specifying the properties (molecular weight, logP, number of hydrogen bond acceptors or donors). </p>
      </div>

      <div class="box-item">
        <div class="title1">● Search by compound structures</div>
        <div class="img"><img src="../assets/pic/001.jpg" alt=""></div>
        <div class="text">
          <p>1.Input SMILES format of the natural product (NP) structure, use ‘,’ to separate multiple SMILES.</p>
          <p>2.Upload MOL2 or SDF format of NP structures.</p>
          <p>3.Input the name of NP.</p>
          <p>4.Access the detail of the NP through the links.</p>
          <p>5.Access the anti-inflammatory activity and molecular targets data through this link.</p>
        </div>
      </div>

       <div class="box-item">
        <div class="title1">● Search by compound properties</div>
        <div class="img"><img src="../assets/pic/002.jpg" alt=""></div>
        <div class="text">
          <p>1.Define the range of the properties.</p>
          <p>2. List of the InflamNat NPs that fit into the property requirements.</p>
          <p>3.Access the detail of the NP through the links.</p>
          <p>4.Access the anti-inflammatory activity and molecular targets data through this links.</p>
        </div>
      </div>

      <div class="box-item">
        <div class="title1">2.  Search by target</div>
        <div class="img"><img src="../assets/pic/003.jpg" alt=""></div>
        <div class="text">
          <p>1.Input the ChEMBL ID of the protein.</p>
          <p>2.Input the name of the protein.</p>
          <p>3.Access the detail of the protein through the links.</p>
          <p>4.Access the InflamNat NPs that target this protein.</p>
        </div>
      </div>

      <div class="box-item">
        <div class="title1">3. Visualize the compound-target network</div>
        <div class="img">
         <img src="../assets/pic/004.jpg" alt="">
        </div>
        <div class="text">
          <p>1. Select Compound or Target as the central node.</p>
          <p>2. Click to browse the list of compounds or targets.</p>
          <p>3. Click to select this compound or target.</p>
          <p>4. Search by entering ChEMBL ID or Name.</p>
          <p>5. Click to visualize the network (the targets that directly influenced by the givin compound, or the compounds that directly influence the given target).</p>
          <p>6. Adjust the visualization parameters</p>
        </div>
      </div>

      <div class="box-item">
        <div class="title1">4. Predict the anti-inflammatory activity (NO production inhibition) of given NPs </div>
        <div class="img">
          <img src="../assets/pic/005.jpg" alt="">
        </div>
        <div class="text">
          <p>1. Enter the SMILES of your query NPs .</p>
          <p>2. Enter a name that you want to be called.</p>
          <p>3. Provide a valid email address to receive the predict results, check the Trash of the mailbox if necessary.</p>
          <p>4. Enter a ID for your job.</p>
          <p>5. Click to start the prediction.</p>
        </div>
      </div>
    </div>

    <div class=" box-item">
      <div class="title1">5.  Predict the compound-target relationship</div>
      <div class="text">
        <p>● Predict the relationship of the given compound and target</p>
      </div>
      <div class="img">
       <img src="../assets/pic/006.jpg" alt="">
      </div>
      <div class="text">
        <p>1. Browse to select a compound</p>
        <p>2. Browse to select a target.</p>
        <p>3. Submit to get the prediction result.</p>
        <p>4. Relationship_Predict = 0: The compound (< 50 μM) CANNOT directly modulate the protein.
          Relationship_Predict = 1: The compound (< 50 μM) directly modulates the protein.
        </p>
      </div>
      <div class="text">
        <p>● Predict the potential targets for the given compound(with the predicted score >0.9)</p>
      </div>
      <div class="img">
       <img src="../assets/pic/007.jpg" alt="">
      </div>
      <div class="text">
        <p>1. Browse to select a compound</p>
        <p>2. Predicted targets for the compound with the score > 0.9.</p>
        <p>3. Predict score.</p>
        <p>4. Click to see the detail of the target.
        </p>
      </div>
    </div>


    <div class=" box-item">
      <div class="title1">6. Download the complete data</div>
       <div class="img">
       <img src="../assets/pic/008.jpg" alt="">
      </div>
    </div>

    <el-backtop target=".page-component__scroll .el-scrollbar__wrap" :bottom="100">
    <div style="{height:100%;width: 100%;background-color: #f2f5f6;box-shadow: 0 0 6px rgba(0,0,0, .12);text-align: center;
    line-height: 40px;color: #1989fa;}">
      UP
    </div>
  </el-backtop>
  </div>
</template>

<script>
export default {
  name: "help",
};
</script>

<style scoped>
/* @import '../css/public.css'; */
.page-guide{padding:0 100px;margin:0 auto;}
.box-item{margin:0 0 30px 0;}
.title {font-size:30px;font-weight:600;height:50px;color:#409EFF;border-bottom:2px solid rgb(245,166,20);text-align:center;}
.text1 {height:100px;font-size:22px;}
.link-list {margin:10px 0px;}
.title1 {font-size:24px;font-weight:600;margin:10px 20px;}
.text {padding:10px 20px;margin:0 0 10px 0;background: #F5F7F9;border-radius:4px;color:#3B454E;text-indent:2em;font-size:22px;color:#3B454E;}
.text p{margin:0 0 3px 0;font-size:22px;}
.box-item img{display:block;width:75%;margin-left: 30px;;margin-bottom: 20px;height:auto;border:#eee solid 2px;box-sizing:border-box;border-radius:6px;}

</style>